import { Fragment } from "react";
import { IntlProvider } from "react-intl";
import content from "./content";
import { LOCALES } from "./locales";

const Provider = ({ children, locale = LOCALES.ENGLISH }) => (
  <IntlProvider
    locale={locale}
    textComponent={Fragment}
    messages={content[locale]}
  >
    {children}
  </IntlProvider>
);

export default Provider;
